/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function ImagesFieldset(props) {
  const { arrayHelpers, t } = props;

  const handleAddImage = () => {
    arrayHelpers.push({ label: '', url: '', is_default: false });
  };

  const jsx = (
    <FormikConsumer>
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <div>
          <Button color="primary" onClick={() => handleAddImage()} className="btn-sm mt-3 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Image')}
          </Button>
          {errors.images && !Array.isArray(errors.images) && touched.images && (
            <div className="text-danger pt-1">{errors.images}</div>
          )}

          {values && values.images && values.images.map((image, index) => (
            <div key={index}>
              <div className="d-flex align-items-center mb-4">
                {image.url !== '' && (
                  <div className="flex-shrink-0 me-3">
                    <img src={image.url} alt={image.label} className="rounded" style={{ maxWidth: '10rem', maxHeight: '10rem' }} />
                  </div>
                )}

                <div className="flex-grow-1">
                  <div className={`${image.url === '' ? 'h' : 'v'}stack gap-3`}>
                    <div>
                      <Field name={`images[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                      <ErrorMessage
                        name={`images[${index}].label`}
                        component="div"
                        className="text-danger pt-1"
                      />
                    </div>

                    <div>
                      <InputGroup>
                        <Field name={`images[${index}].url`} type="text" className="form-control" placeholder={t('URL')} />
                        <Button
                          type="button"
                          onClick={() => arrayHelpers.remove(index)}
                          color="danger"
                          className="btn-soft-danger"
                        >
                          <span className="mdi mdi-close-thick" />
                        </Button>
                      </InputGroup>
                      <ErrorMessage
                        name={`images[${index}].url`}
                        component="div"
                        className="text-danger pt-1"
                      />
                    </div>

                    <div className="form-check">
                      <label htmlFor={`images${index}_is_default`} className="form-check-label">{t('Default Image')}</label>
                      <Field
                        type="radio"
                        className="form-check-input"
                        id={`images${index}_is_default`}
                        name={`images[${index}].is_default`}
                        value="1"
                        onChange={() => {
                          values.images.forEach((_image, i) => {
                            if (i !== index) {
                              setFieldValue(`images[${i}].is_default`, false);
                            }
                          });
                          setFieldValue(`images[${index}].is_default`, true);
                        }}
                        checked={values.images[index].is_default}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

ImagesFieldset.defaultProps = {
  t: (x) => (x),
};

ImagesFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(ImagesFieldset));
